import { inject } from "@angular/core";
import { type CanActivateFn, Router } from "@angular/router";
import { AccountService } from "app/shared/services/account.service";
import { Account } from "app/shared/types/account.type";
import { Token } from "app/shared/types/token.type";

export const flutterExistingRegistrationWebViewGuard: CanActivateFn = (
  route,
) => {
  const flutterDataExistingAccountRegistration = route.queryParamMap.get(
    "flutterDataExistingAccountRegistration",
  );
  if (flutterDataExistingAccountRegistration === null) {
    console.log(
      "No flutter data for existing account registration found, allowing access to route",
    );
    return true;
  }
  console.log(
    "Flutter data for existing account registration found, processing login",
  );
  const accountService = inject(AccountService);
  const {
    email,
    password,
    token,
    id,
  }: { email: string; password: string; token: string; id: string } =
    JSON.parse(decodeURIComponent(flutterDataExistingAccountRegistration));
  const router = inject(Router);
  if (token && id) {
    const accountObj: Account = new Account();
    accountObj.id = id;
    accountService.findBytoken(accountObj, token).subscribe({
      next: (account) => {
        if (account) {
          const tokenObject: Token = {
            id: token,
            ttl: "43200",
            user: account,
            userId: account.id,
          };
          accountService.setSessionInfo(tokenObject, account);
          router.navigate(["/register/complete"]);
        }
      },
    });
  } else {
    accountService
      .login({
        email,
        password,
      })
      .subscribe({
        next: () => {
          router.navigate(["/register/complete"]);
        },
      });
  }
  return false;
};
